/* THE ROSTER, EIGHT FRAMES EACH.
 *
 * Every actor in the game was two frames. An art review counted it — "11 of 11
 * actors have exactly 2 frames; 0 have 3+" — and scored animation 4/10.
 *
 * These live outside `art.ts` for two reasons. `art.ts` was already 2,400
 * lines, and eleven eight-frame sets would have made it the largest file in
 * the project by a wide margin; and one module per actor is what let them be
 * authored in parallel without eleven writers fighting over one file.
 *
 * They are pure data — no imports, no canvas, nothing to evaluate — so
 * `art.ts` can merge them into `S` with no risk of a cycle.
 */
import * as bramble from './bramble.ts';
import * as charger from './charger.ts';
import * as charger_down from './charger_down.ts';
import * as charger_up from './charger_up.ts';
import * as forager_down from './forager_down.ts';
import * as forager_side from './forager_side.ts';
import * as forager_up from './forager_up.ts';
import * as shellback from './shellback.ts';
import * as shellback_down from './shellback_down.ts';
import * as shellback_up from './shellback_up.ts';
import * as sporeling from './sporeling.ts';
import * as wisp from './wisp.ts';
import * as gloam from './gloam.ts';
import * as cinder from './cinder.ts';
import * as eel from './eel.ts';
import * as tidecrab from './tidecrab.ts';
import * as mossback from './mossback.ts';
import * as sunbasker from './sunbasker.ts';
import * as screehopper from './screehopper.ts';
import * as stormgull from './stormgull.ts';
import * as duskling from './duskling.ts';

/** How many frames a cycle has. Exported so the animation clocks and the
 *  checks read the same number instead of each spelling `8`. */
export const FRAMES = 8;

const MODULES = [bramble, charger, charger_down, charger_up,
  forager_down, forager_side, forager_up,
  shellback, shellback_down, shellback_up, sporeling, wisp, gloam, cinder, eel, tidecrab, mossback, sunbasker, screehopper, stormgull, duskling];

/** Every `<actor>_<n>` matrix, flattened into one table. */
export const SPRITES: Record<string, string[]> = {};
for (const mod of MODULES) {
  for (const [name, rows] of Object.entries(mod)) {
    if (Array.isArray(rows)) SPRITES[name] = rows as string[];
  }
}
